<template>
  <div class="container">
    <div class="report-pc">
      <Pc ref="pcComponent"  />
    </div>
    <div class="report-h5">
      <H5 ref="h5Component" />
    </div>
  </div>
</template>

<script>
import Pc from "./components/pc/index";
import H5 from "./components/h5/index";
export default {
  name: "",
  components: { Pc, H5 },
  data() {
    return {};
  },

  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>

</style>
